// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-card[data-v-3ddfa0e0] {\n  border: 1px solid #cfd8e9 !important;\n  box-shadow: 0px 3px 10px #eaedf1 !important;\n  border-radius: 7px !important;\n}\n", ""]);
// Exports
module.exports = exports;
